module.exports = __webpack_public_path__ + "static/media/following-you-video.79e9dc29.jpg";